/**
 * Placeholder pricing constants for the PoC's trip fuel/RUC cost estimates
 * (see TripDetailsPage.vue). These are not sourced from any live pricing
 * API or NZTA rate schedule - they exist so the feature can be demoed with
 * plausible NZ figures, and must be replaced with a real rate source before
 * this leaves PoC status.
 */

/** Indicative average NZ pump price, in NZD per litre. */
export const FUEL_PRICE_PER_LITRE = 2.75;

/**
 * Indicative NZ light-diesel RUC rate, in NZD per km.
 *
 * Real RUC rates are banded by vehicle weight/axles and sold in 1000km
 * units, not charged as a flat per-km rate - this PoC uses one flat rate
 * for simplicity.
 */
export const RUC_COST_PER_KM = 0.076;
